export const LOCAL_STORAGE_KEYS = {
  ACL_TABLE_SETTINGS: 'aclTableSettings',
  SUBSCRIPTION_PLAN_TABLE_SETTINGS: 'subscriptionPlanTableSettings',
  SUBSCRIPTION_PLAN_PRICE_TABLE_SETTINGS: 'subscriptionPlanPriceTableSettings',
  SUBSCRIPTION_RESTRICTION_TABLE_SETTINGS:
    'subscriptionRestrictionTableSettings',
  ADMIN_USER_TABLE_SETTINGS: 'adminUserTableSettings',
  EXERCISE_PROPERTY_TABLE_SETTINGS: 'exercisePropertyTableSettings',
  BUG_REPORT_TYPE_TABLE_SETTINGS: 'bugReportTypeTableSettings',
  APP_VARIABLE_TABLE_SETTINGS: 'appVariableTableSettings',
  APP_FEATURE_TABLE_SETTINGS: 'appFeatureTableSettings',
  AI_PROMPT_TABLE_SETTINGS: 'aiPromptTableSettings',
  EXERCISE_LOAD_FORMULA_TABLE_SETTINGS: 'exerciseLoadFormulaTableSettings',
  TRAINING_ACTIVITY_TYPE_TABLE_SETTINGS: 'trainingActivityTypeTableSettings',
  NOTIFICATION_TEMPLATES_TABLE_SETTINGS: 'notificationTemplatesTableSettings',
  NOTIFICATION_TEMPLATE_DETAIL_TRANSLATIONS_TABLE_SETTINGS:
    'notificationTemplateDetailTranslationsTableSettings',
  NOTIFICATION_CAMPAIGNS_TABLE_SETTINGS: 'notificationCampaignsTableSettings',
};
